
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { useNavigate } from 'react-router-dom';
import { Building2, Clock, Plus, Settings, BookOpen } from 'lucide-react';

interface QuickActionsProps {
  pendingCount: number;
  pendingTutorials?: number;
}

const QuickActions = ({ pendingCount, pendingTutorials = 0 }: QuickActionsProps) => {
  const navigate = useNavigate();

  const quickActions = [
    {
      title: "Management",
      description: "Manage manufacturers, printers, filaments, and tutorials",
      icon: Building2,
      onClick: () => navigate("/admin/management")
    },
    {
      title: "Review Pending Submissions",
      description: "Review new submissions awaiting approval",
      icon: Clock,
      onClick: () => navigate("/admin/submissions?filter=pending"),
      badge: pendingCount > 0 ? pendingCount : null
    },
    {
      title: "Tutorial Management",
      description: "Manage tutorials and pending approvals",
      icon: BookOpen,
      onClick: () => navigate("/admin/management"),
      badge: pendingTutorials > 0 ? pendingTutorials : null
    },
    {
      title: "Add New Component",
      description: "Add a new component to the database",
      icon: Plus,
      onClick: () => navigate("/admin/components?action=add")
    },
    {
      title: "System Settings",
      description: "Configure platform settings",
      icon: Settings,
      onClick: () => console.log("Settings not implemented yet")
    }
  ];

  return (
    <div>
      <h2 className="text-xl font-semibold mb-4">Quick Actions</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {quickActions.map((action, index) => (
          <Card key={index} className="cursor-pointer hover:shadow-md transition-shadow" onClick={action.onClick}>
            <CardContent className="p-6">
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-3">
                  <action.icon className="h-8 w-8 text-primary" />
                  <div>
                    <h3 className="font-semibold">{action.title}</h3>
                    <p className="text-sm text-muted-foreground">{action.description}</p>
                  </div>
                </div>
                {action.badge && (
                  <Badge variant="destructive">{action.badge}</Badge>
                )}
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default QuickActions;
